import {
	RESET_STATE,
	SET_LEGALS,
	SET_LEGALS_SEARCH_VALUE,
	SET_IS_LEGALS_LOADING,
	SET_PAGINATION,
	SET_IS_DOWNLOAD_LOADING,
} from './actions';

export const initialState = {
	isLegalsLoading: false,
	isDownloadLoading: false,
	legals: [],
	legalsSearchValue: '',
	pagination: null,
};

const legalsReducer = (state = initialState, action) => {
	const { type, payload } = action;
	switch (type) {
		case SET_LEGALS:
			return {
				...state,
				legals: payload,
			};
		case SET_IS_LEGALS_LOADING:
			return {
				...state,
				isLegalsLoading: payload,
			};
		case SET_IS_DOWNLOAD_LOADING:
			return {
				...state,
				isDownloadLoading: payload,
			};
		case SET_LEGALS_SEARCH_VALUE:
			return {
				...state,
				legalsSearchValue: payload,
			};
		case SET_PAGINATION:
			return {
				...state,
				pagination: payload,
			};
		case RESET_STATE:
			return initialState;
		default:
			return state;
	}
};

export default legalsReducer;
